/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import z_indexGif from 'assets/images/z-index.gif'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Свойство z-index</h2>
    <p className={styles.description}>
      До свойства <code className={styles.code}>position</code> мы не придавали большого значения расположению элементов
      по оси <code className={styles.code}>z</code> (перпендикуляру к плоскости экрана). Расположение элементов в этой
      плоскости было интуитивно понятно. Предок располагался внизу, подобно листу бумаги, а потомок - словно новый лист
      бумаги, который ложится сверху. И чем больше потомков было у элемента, тем больше было таких слоев.{' '}
    </p>
    <p className={styles.description}>
      Но применение <code className={styles.code}>position</code> все изменило. В отличие от элементов{' '}
      <code className={styles.code}>float</code>, которые выпадают из потока, но не перекрывают друг друга, элементы с{' '}
      <code className={styles.code}>position</code>, отличном от <code className={styles.code}>static</code>, ведут себя
      по другому. Элементы выпадают из потока, а значит для таких элементов нужно правило, которое будет определять
      какой элемент находится выше, а какой ниже. Это правило задает свойство{' '}
      <code className={styles.code}>z-index</code>, значениями которого может быть любое целое число, в том числе и
      отрицательное.{' '}
    </p>
    <img className={styles.img} src={z_indexGif} alt="z-index" />

    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.1 - Правила применения</h3>
      <p className={styles.description}>
        Общий предок создает <code className={styles.code}>контекст</code>, область в которой{' '}
        <code className={styles.code}>z-index</code> элементов оказывает влияние на другие элементы с{' '}
        <code className={styles.code}>z-index</code>. Внутри этого контекста значение{' '}
        <code className={styles.code}>z-index</code> может быть больше других и тогда элемент располагается сверху.{' '}
      </p>
      <p className={styles.description}>
        Минимальное (даже отрицательное) значение <code className={styles.code}>z-index</code> говорит о том, что другие
        элементы вне потока будут выше этого элемента. И в случае равенства значения{' '}
        <code className={styles.code}>z-index</code> (это значение по умолчанию) выше будет элемент объявленный
        последним.{' '}
      </p>
      <p className={styles.description}>
        Исключением из правил может стать ситуация, когда какой-то из предков без свойства{' '}
        <code className={styles.code}>z-index</code> получит полупрозрачный фон, т.е. его{' '}
        <code className={styles.code}>opacity</code> станет отличной от 1. В таком случае происходит формирование нового
        контекста и подобных случаев лучше избегать в виду неочевидности применения правил из-за неожиданного появления
        нового общего предка.
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="relative_shift"
        src="https://codepen.io/GoIT-fe/embed/MvbBMz?default-tab=html%2Cresult"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
      <a
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
        href="https://css-tricks.com/almanac/properties/p/position/"
      >
        CSS-Tricks: position
      </a>{' '}
    </section>
  </section>
))
